import script from "./MapStandalone.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapStandalone.vue?vue&type=script&setup=true&lang=ts"

import "./MapStandalone.vue?vue&type=style&index=0&id=56ef4bee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ef4bee"]])

export default __exports__